import { render, staticRenderFns } from "./CharactersList.vue?vue&type=template&id=33d161ec"
import script from "./CharactersList.vue?vue&type=script&lang=js"
export * from "./CharactersList.vue?vue&type=script&lang=js"
import style0 from "./CharactersList.vue?vue&type=style&index=0&id=33d161ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports